import React from "react";
import { Box, Grid, Typography, } from "@material-ui/core";

const ErrorPageWebViewUnAuth: React.FC = (props: any) => {
  return (
    <Box style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Grid container item xs={10} sm={8} md={6} justify="center" direction="column" spacing={2}>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <img
        src="/web-view-error.png"
        alt="responsive"
        style={{
          width: '100%',
          maxWidth: 80,
          height: 'auto',
        }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography align="center" variant="h5" style={{color: "black", fontWeight: 'bold'}}>
        Йой, щось сталось
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography align="center" variant="body1" style={{color: "black", wordBreak: 'break-word', fontWeight: 'bold'}}>
        Необхідно оновити сесію. 
        </Typography>
        <Typography align="center" variant="body2" style={{color: "black", wordBreak: 'break-word', fontWeight: 'bold'}}>
        Поверніться до застосунку «Мій Нотаріус» і спробуйте знову.
        </Typography>
      </Grid>
      </Grid>
    </Box>
  );
};

export default ErrorPageWebViewUnAuth;
